var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item',{attrs:{"to":"/admin"}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-shield-crown")])],1),_c('v-list-item-title',[_vm._v("Admin")])],1),_c('v-divider',{staticClass:"mb-3 mt-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }